export const AUTH_TOKEN = 'id_token';
//TODO: MOVE TO CONSTANTS PACKAGE
